// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { buscarUsuarioLeadByCelService } from "../../../services/buscarUsuarioLeadByCelService";

export const useVerficacaoLead = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const verificacao = async (celular: string) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const verificarDados = await buscarUsuarioLeadByCelService(celular);

      if (verificarDados) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { verificacao, isLoading, isSuccess, error, success };
};
